import React, { useState, useEffect } from "react";
import { Row, Col } from "antd";
import MyDocsForm from "../../Form/PermissionForm/components/MyDocsForm";
import SettingsForm from "../../Form/PermissionForm/components/SettingsForm";
import ComplianceForm from "../../Form/PermissionForm/components/ComplianceForm";
import ULPForm from "../../Form/PermissionForm/components/ULPForm";
import QMSForm from "../../Form/PermissionForm/components/QMSForm";
import SystemManagerAdminForm from "../../Form/PermissionForm/components/SystemManagerAdminForm";
import UserDefaultPermission from "../../Form/PermissionForm/UserDefaultPermission";
import UserIndexPermission from "../../UserPermission/UserIndexPermission";
import UserProjectPermission from "../../UserPermission/UserProjectPermission";
import DashboardFrom from "../../Form/PermissionForm/components/DashboardFrom";
import SecretKeyManagerForm from "../../Form/PermissionForm/components/SecretKeyManagerForm";
import MYPForm from "../../Form/PermissionForm/components/MYPForm";
import PNAForm from "../../Form/PermissionForm/components/PNAForm";

const PermissionSelection = (props) => {
  const {
    current,
    defaultPermissionOnChange,
    disabledState,
    getFieldValue,
    setFieldsValue,
    indexPermissions,
    setIndexPermissions,
    indexList,
    additionalParameters,
    isAdmin,
    indexPermissionHandler,
    hmgPermissionUpdate,
  } = props;

  const [solution, setSolution] = useState("");
  useEffect(() => {
    if (current === 0) {
      setSolution("");
      setFieldsValue({ user_permission: "" });
    }
  }, [current]);

  return (
    <div>
      <UserDefaultPermission
        name=""
        defaultPermissionOnChange={defaultPermissionOnChange}
        disabledState={disabledState}
      />

      <Row style={{ marginTop: "16px" }}>
        <Col span={24}>
          {isAdmin && <DashboardFrom disabledState={disabledState} />}

          <MyDocsForm
            disabledState={disabledState}
            getFieldValue={getFieldValue}
            setFieldsValue={setFieldsValue}
            isAdmin={isAdmin}
          />
          <SettingsForm
            disabledState={disabledState}
            setFieldsValue={setFieldsValue}
            getFieldValue={getFieldValue}
          />
          <ComplianceForm
            getFieldValue={getFieldValue}
            disabledState={disabledState}
            setFieldsValue={setFieldsValue}
          />
          <ULPForm
            disabledState={disabledState}
            getFieldValue={getFieldValue}
            setFieldsValue={setFieldsValue}
            isAdmin={isAdmin}
          />
          <QMSForm
            disabledState={disabledState}
            getFieldValue={getFieldValue}
            setFieldsValue={setFieldsValue}
            isAdmin={isAdmin}
          />
          {isAdmin && <SecretKeyManagerForm disabledState={disabledState} />}
          <MYPForm
            disabledState={disabledState}
            getFieldValue={getFieldValue}
            setFieldsValue={setFieldsValue}
            isAdmin={isAdmin}
          />
          <PNAForm disabledState={disabledState} />
          {indexList.length > 0 && (
            <>
              <UserProjectPermission
                disabledState={disabledState}
                indexList={indexList}
                additionalParameters={additionalParameters}
              />
              <UserIndexPermission
                disabledState={disabledState}
                indexPermissions={indexPermissions}
                setIndexPermissions={setIndexPermissions}
                indexList={indexList}
                indexPermissionHandler={indexPermissionHandler}
                additionalParameters={additionalParameters}
                hmgPermissionUpdate={hmgPermissionUpdate}
              />
            </>
          )}
          <SystemManagerAdminForm
            disabledState={disabledState}
            getFieldValue={getFieldValue}
            setFieldsValue={setFieldsValue}
            isAdmin={isAdmin}
          />
        </Col>
      </Row>
    </div>
  );
};

export default PermissionSelection;